/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import { gql } from '@apollo/client';

const findProductRecommendationsSF = (queryName = 'collectionRecommendationsSF') => (
    gql`query ${queryName} (
        $brand: String!
        $environment: String!
        $user: UserSF!
        $targeting: TargetingSF!
        $userAttributes: [UserAttributesSF]
        $isHoldoutEligible: Boolean!
        $resolveIdentity: Boolean!
    ) {
        collectionRecommendations(
            brand: $brand,
            environment: $environment,
            user: $user,
            targeting: $targeting,
            userAttributes: $userAttributes,
            isHoldoutEligible: $isHoldoutEligible
            resolveIdentity: $resolveIdentity
        ) {
            campaign
            content
            collections{
                name,
                id,
                path,
                image{
                    path,
                    name
                },
                products{
                    name,
                    partNumber,
                    image{
                        path,
                        name
                    }
                }
            }
            isHoldOut
        }
    }`
);

export default findProductRecommendationsSF;
